import React from 'react'
// 
import Spinner from '../../../_metronic/assets/gifs/480px-Loader.gif'
const FullPageLoader = () => {
    return (
        <div className="fp-container">
            <img src={Spinner} className="fp-loader" alt="loading" />

        </div>)
}

export default FullPageLoader